@if (hasPermissionToMainDashboard$ | async) {
    <medpace-main-dashboard></medpace-main-dashboard>
}

@if (hasPermissionToCrcDashboard$ | async) {
    <medpace-crc-dashboard></medpace-crc-dashboard>
}
